import React from "react"
import { connect } from "react-redux";
import { constants } from "../../Constants";
import sessionDetailService from "../../static/images/session-detail-service.svg"
import sessionDetailCalender from "../../static/images/session-detail-calendar.svg"
import sessionDetailClock from "../../static/images/session-detail-clock.svg"
import maximumAllowedSessionIcon from "../../static/images/maximumAllowedSession.svg";
import totalRemainingSessionIcon from "../../static/images/totalRemainingSession.svg";
import "./sessionPatientDetail.css"
import { getDateTimeAndDuration, getSessionsRemaining } from "../../helpers";
import { withRouter } from "react-router-dom";

class SessionPatientDetails extends React.Component {
    constructor(props) {
        super(props);

    }
    render() {
        let isDisabled = getSessionsRemaining(this.props.totalSessionCaps, this.props.consumedSessionCaps) === 0;
        const { duration } = getDateTimeAndDuration(`${this.props.sessionDate} ${this.props.sessionTime}`);
        const isMyClientDetailView = this.props.location.state && this.props.location.state.isMyClientDetailView;

        return (
            <div className="sh-patient-dash-comp sh-gnrl-width mb-5 mt-3">
                <React.Fragment>
                    <h3
                        className="sh-gnrl-welcome text-center">{this.props.detailHeading}
                    </h3>
                    <div className="sh-session-container d-flex flex-column align-items-center">
                        <div className="sh-image-holder">
                            {this.props.profileImage ?
                                    <img src={this.props.profileImage}/> :  <p>{this.props.initials}</p>}
                        </div>
                        <div className="user-name text-center">
                            <h2>{this.props.userName}</h2>
                            <p className="text-dark text-center">{this.props.specialities ? <span><b>Specialities: </b>{this.props.specialities}</span> : 'Patient'}</p>
                        </div>
                        <div className="text-dark booking-details-container sh-gnrl-container w-100">
                            {isMyClientDetailView ? (
                                <b className="text-dark">
                                    {constants.DETAILS_TXT}
                                </b>
                            ) : (
                                <b className="text-dark">
                                    {constants.BOOKING_DETAILS_TXT}
                                </b>
                            )}
                            <div className="booking-details pt-2 pb-2 border border-right-0 border-left-0 border-top-0 border-bottom-1 d-flex justify-content-between align-items-center">
                                <div className="sh-icon">
                                    <img src={sessionDetailCalender} />
                                </div>
                                <div className="sh-detail">
                                    {this.props.sessionDate}
                                </div>
                            </div>

                            {!isMyClientDetailView && (
                                <div className="booking-details pt-2 pb-2 border border-right-0 border-left-0 border-top-0 border-bottom-1 d-flex justify-content-between align-items-center">
                                    <div className="sh-icon">
                                        <img src={sessionDetailClock} />
                                    </div>
                                    <div className="sh-detail">
                                        {duration}
                                    </div>
                                </div>
                            )}

                            {this.props.showServiceType && <div className="booking-details pt-2 pb-2 d-flex justify-content-between align-items-center">
                                <div className="sh-icon">
                                    <img src={sessionDetailService} />
                                </div>
                                <div className="sh-st-badge badge serviceType-tag-style">
                                    {this.props.serviceType}
                                </div>
                            </div>}
                        </div>
                    </div>

                    <div className="mt-3 sh-session-container d-flex flex-column align-items-center">
                        <div className="text-dark booking-details-container sh-gnrl-container w-100 d-flex flex-column">
                            <b className="text-dark">
                                {constants.SESSION_CAP_TXT}
                            </b>
                            {this.props.isSessionCapAllowed ?
                                <React.Fragment>
                                    <div className="booking-details pt-2 pb-2 border border-right-0 border-left-0 border-top-0 border-bottom-1 d-flex justify-content-between align-items-center">
                                        <div className="sh-icon">
                                            <img src={maximumAllowedSessionIcon} />
                                        </div>
                                        <div className="sh-detail">
                                            {`${constants.MAXIMUM_ALLOWED_SESSIONS_TXT} ${this.props.totalSessionCaps}`}
                                        </div>
                                    </div>

                                    <div className="booking-details pt-2 pb-2 border border-right-0 border-left-0 border-top-0 border-bottom-1 d-flex justify-content-between align-items-center">
                                        <div className="sh-icon">
                                            <img src={totalRemainingSessionIcon} />
                                        </div>
                                        <div className="sh-detail">
                                            {`${constants.TOTAL_REMAINING_TXT} ${getSessionsRemaining(this.props.totalSessionCaps, this.props.consumedSessionCaps)}`}
                                        </div>
                                    </div>
                                </React.Fragment> : <span className="mt-1">{constants.NO_SESSION_CAP_TXT}</span>
                            }
                            {this.props.canReset && (
                                <div className="mt-2 text-center">
                                    <button
                                        disabled={isDisabled}
                                        onClick={this.props.resetHandler}
                                        className={`session-reset-btn ${isDisabled ? 'disabled cursor-not-allowed' : ''}`}>
                                        Reset
                                    </button>
                                </div>
                            )}

                        </div>
                    </div>
                </React.Fragment>
            </div>
        )
    }
}

export default withRouter(SessionPatientDetails);


// WEBPACK FOOTER //
// ./src/components/SessionAndPatientDetail/SessionPatientDetail.js